import { render, staticRenderFns } from "./TableDiscount.vue?vue&type=template&id=5cd8ad98&scoped=true&"
import script from "./TableDiscount.vue?vue&type=script&lang=js&"
export * from "./TableDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TableDiscount.vue?vue&type=style&index=0&id=5cd8ad98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8ad98",
  null
  
)

export default component.exports